import { PropsWithChildren } from 'react';

import { Stack, Typography } from 'libs/ui';

export interface SectionProps extends PropsWithChildren {
  title: string;
}

export const Section = ({ title, children }: SectionProps) => (
  <Stack spacing={12}>
    <Typography as="h3" variant="subtitle">
      {title}
    </Typography>

    {children}
  </Stack>
);
